import { Component, OnInit, Input, Output, EventEmitter, TemplateRef, ViewChildren, SimpleChanges} from '@angular/core';

import { UtilService } from 'src/app/modules/shared/services/util.service';
import { CouponsService } from 'src/app/modules/retailer/services/coupons.service';

@Component({
  selector: 'app-manage-manufacturer',
  templateUrl: './manage-manufacturer.component.html',
  styleUrls: ['./manage-manufacturer.component.scss']
})
export class ManageManufacturerComponent implements OnInit {

  @Input() module: string; // (CPG/RETAILER/ADMIN)
  @Output() actions = new EventEmitter(); // Actions from component

  public loginData: any;

  public manufacturers: any = [];
  public currentAction: string;

  public mfgName!: string;

  constructor(
    private _utilService: UtilService,
    private _couponsService: CouponsService
  ) { }

  ngOnInit(): void {
    this.getStorageData();
  }

  async getStorageData() {
    if(this.module == 'RETAILER') {
      this.loginData = await this._utilService.getStorageData('R_LOGIN');
    } else if(this.module == 'ADMIN') {
      this.loginData = await this._utilService.getStorageData('A_LOGIN');
    }

    this.getManufacturers();
  }

  // Get manufacturers
  getManufacturers() {
    this.manufacturers = [];
    this.currentAction = 'getManufacturers';

    this._couponsService.getManufacturers(this.loginData.token, this.loginData.user_details.provider_type, this.loginData.user_details.provider_id, false).subscribe(async getManufacturersResponse => {
      this.currentAction = '';
      
      if (getManufacturersResponse.status === true) { // Success
        this.manufacturers = getManufacturersResponse.manufacturers;
      } else {
        this._utilService.showToast(getManufacturersResponse.message, '', 'error', {});
      }
    }, error2 => { // Error from getManufacturers
      this.currentAction = '';
    });
  }

  // Add/edit/delete manufacturer
  manageManufacturer() {
    if (!this.mfgName) {
      this._utilService.showToast('Please enter new manufacturer name', '', 'warning', {});
    } else {
      this.currentAction = 'manageManufacturer';

      let manageManufacturerBody: any = {
        mode: 'add', 
        name: this.mfgName
      }

      this._couponsService.manageManufacturer(this.loginData.token, manageManufacturerBody).subscribe(async manageManufacturerResponse => {
        this.currentAction = '';

        if (manageManufacturerResponse.status === true) { // Success
          this._utilService.showToast('New manufacturer "' + this.mfgName + '" is added.', '', 'success', {});
          this.actions.emit({ action: 'added' });
        } else {
          this._utilService.showToast(manageManufacturerResponse.message, '', 'error', {});
        }
      }, error2 => { // Error from manageManufacturer
        this.currentAction = '';
      });
    }
  }

}
